import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Icon, Typography, Button, ButtonMenu } from '@ann/web-components';
import { 
    GranteesListContainerInternal, 
    GranteesListContainerExternal,
    GranteesListScrollWrapper,
    GranteeItem, 
    GranteeInfo, 
    GranteeActions,
    CollapsibleContainer, 
    CollapsibleHeader, 
    HeaderContent, 
    IconContainer 
} from '../Modal.styled';
import { NameInitialsAvatar } from 'react-name-initials-avatar';

const CurrentGranteesList = observer(({
    shouldShow,
    grantees,
    isLoading,
    currentSelectionType,
    privileges,
    onUpdatePermission,
    onRemove
}) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!shouldShow) return null;

    return (
        <CollapsibleContainer>
            <CollapsibleHeader onClick={() => setIsOpen(!isOpen)}>
                <HeaderContent>
                    <Typography category="subtitle" size="small" weight="bold" color="subtitle">
                        View who has access
                    </Typography>
                    <Typography category="body" size="medium" weight="regular" color="body">
                        {grantees.length} users currently have access
                    </Typography>
                </HeaderContent>
                <IconContainer>
                    <Icon
                        name={isOpen ? "chevronUp" : "chevronDown"}
                        size={24}
                        color="secondary"
                    />
                </IconContainer>
                   
            </CollapsibleHeader>

            {isOpen && (
                <GranteesListScrollWrapper>
                    <GranteesListContainerExternal>
                        <GranteesListContainerInternal>

                        {isLoading ? (
                            <Typography category="body" size="medium" color="secondary">
                                Loading...
                            </Typography>
                        ) : grantees.length === 0 ? (
                            <Typography category="body" size="medium" color="secondary">
                                No users have access yet
                            </Typography>
                        ) : (
                            grantees.map((grantee) => (
                                <GranteeItem key={grantee.grantee_uuid}>
                                    <GranteeInfo>
                                        <NameInitialsAvatar
                                            name={grantee.grantee_name}
                                            bgColor="#2563eb"
                                            textColor="#ffffff"
                                            size="24px"
                                            borderRadius="50%"
                                            textWeight="bold"
                                            textSize="18px"
                                            borderColor="#ffffff"
                                            borderStyle="solid"
                                            borderWidth="2px"
                                        />
                                        <Typography
                                            category="body"
                                            size="medium"
                                            weight="regular"
                                            color="body"
                                        >
                                            {grantee.grantee_name} {"mailexmaple@mail.com"}
                                        </Typography>
                                    </GranteeInfo>
                                    <GranteeActions>
                                        <ButtonMenu
                                            iconPosition="right"
                                            label={grantee.privileges[0]?.privilege_name || 'Permission'}
                                            menuPosition="bottom"
                                            onChange={(value) => onUpdatePermission(
                                                grantee.grantee_uuid,
                                                grantee.grantee_type,
                                                value
                                            )}
                                            size="medium"
                                            pill={true}
                                            type="secondary"
                                            className="list-actions"
                                            width="auto"
                                            usePortal={true}
                                            disableEffects={true}
                                        >
                                            <ButtonMenu.Menu>
                                                {privileges[currentSelectionType === 'folder' ? 'folderPrivileges' : 'documentPrivileges'].map((privilege) => (
                                                    <ButtonMenu.Item
                                                        key={privilege.entityPrivilegeUuid}
                                                        label={privilege.privilegeName}
                                                        value={privilege.privilegeName}
                                                    >
                                                        {privilege.privilegeName}
                                                    </ButtonMenu.Item>
                                                )) || []}
                                            </ButtonMenu.Menu>
                                        </ButtonMenu>
                                        <Button
                                            icon="close"
                                            size="medium"
                                            type="tertiary"
                                            onClick={() => onRemove(
                                                grantee.grantee_uuid,
                                                grantee.grantee_type
                                            )}
                                        />
                                    </GranteeActions>
                                </GranteeItem>
                            ))
                        )}
                        </GranteesListContainerInternal>
                    </GranteesListContainerExternal>
                </GranteesListScrollWrapper>
            )}
        </CollapsibleContainer>
    );
});

export default CurrentGranteesList;
